import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "tournament-registration t-text",
  "data-qe-id": "tournament-registration-modal"
}
const _hoisted_2 = {
  key: 0,
  "data-qe-id": "rejoin-text"
}
const _hoisted_3 = { class: "checkbox-group" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "error-text",
  "data-qe-id": "inline-error"
}
const _hoisted_6 = ["innerHTML"]

import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store'
import CTournamentInfo from '@/components/CTournamentInfo.vue'
import CTerms from '@/components/terms/CTerms.vue'
import CErrorModal from '@/components/CErrorModal.vue'
import { Tournament, TournamentUi } from '../model/Tournament'
import { State } from '../store/state'
import { JoinState } from '../store/modules/join'
import { marked } from 'marked'
import { ERROR_CODES } from '../model/ErrorCodes'
import { track } from '@/lib/track'
import { jslog } from '@gd/jslog'


export default /*@__PURE__*/_defineComponent({
  __name: 'MTournamentRegistration',
  emits: ['registration-complete'],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit
const router = useRouter()
const route = useRoute()
const store = useStore()
const { t } = useI18n()

// activate the rejoin flag ( different texts )
const rejoin = ref(false)
const acceptanceBox = ref(false)

const isRegistrationOverlayShown = ref(false)
const isProcessingRegistration = ref(false)
// JoinState.result.reason
const failedReason = ref('')
const failedReasonInline = ref('')

const showTerms = ref(false)

const tournament = computed((): Tournament => {
  return store.state.tournament
})
function clickHandlerTerms(e: Event) {
  const event: any = e
  if (event.target && event.target.tagName === 'A' && event.target.href) {
    if (/#terms/.test(event.target.href)) {
      showTerms.value = true
      e.preventDefault()
    }
  }
}
function clickHandler(e: Event) {
  const event: any = e
  if (event.target && event.target.tagName === 'A' && event.target.href) {
    if (/#customerservice/.test(event.target.href)) {
      const win: any = window.open('/gd/support/contact.xhtml', 'customer')
      win.focus()
    }
  }
  e.preventDefault()
}

const tournamentUi = computed((): TournamentUi => {
  return store.getters.tournamentUi
})

/**
 * Public method to show the registration overlay
 */
function show(conf: { rejoin: boolean }) {
  rejoin.value = conf.rejoin
  isProcessingRegistration.value = false
  failedReason.value = ''
  failedReasonInline.value = ''
  isRegistrationOverlayShown.value = true
}

function closeRegistrationModal() {
  if (!isProcessingRegistration.value) {
    isRegistrationOverlayShown.value = false
  }
}
const balance = computed((): number => {
  return parseFloat((store.state as State).balance.balance)
})
function onRegister() {
  if (!acceptanceBox.value) {
    failedReasonInline.value = t('tRegistration.main.error_acceptance') as string
    return
  }

  if (
    balance.value <
    parseFloat(!rejoin.value ? tournament.value.metaData.entryFee : tournament.value.metaData.restartFee)
  ) {
    failedReasonInline.value = t('tRegistration.main.error_notEnoughMoney') as string
    return
  }

  track({
    path: route.fullPath,
    id: 'tournament-registration',
    data: rejoin.value ? 'rejoin' : 'join',
  })

  isProcessingRegistration.value = true
  store
    .dispatch('join/registerForTournament', (store.state as State).tournament.tournamentId)
    .then(() => {
      if (store.state.join.result.success) {
        store.commit('joinTournament', (store.state as State).tournament.tournamentId)
        isRegistrationOverlayShown.value = false
        isProcessingRegistration.value = false
        emit('registration-complete')
      } else {
        const reason = (store.state.join as JoinState).result.reason as GD_tournaments.FailReason
        if (reason === 'tooMuchMoney') {
          router.replace('/extern/payout')
          return
        }

        isProcessingRegistration.value = false
        failedReason.value = reason
        jslog.send({
          name: 'tournament-registration',
          data: { failedReason: failedReason.value },
        })
      }
      // trigger reload tournament
    })
    .catch((err) => {
      // handle "fatal" errors
      if (err && err.errorCode === 401) {
        router.replace('/extern/login')
      } else {
        jslog.send({
          name: 'tournament-registration',
          data: {
            code: (err && err.errorCode) || ERROR_CODES.UNKNOWN,
            zoneId: (store.state as State).zone.zoneId,
          },
        })
      }
      failedReason.value = 'unknown'
      isProcessingRegistration.value = false
    })
}

function md(text: string): string {
  return marked(text)
}

__expose({
  show,
})

return (_ctx: any,_cache: any) => {
  const _component_c_loading_indicator = _resolveComponent("c-loading-indicator")!
  const _component_modal_title = _resolveComponent("modal-title")!
  const _component_modal_content = _resolveComponent("modal-content")!
  const _component_t_button = _resolveComponent("t-button")!
  const _component_modal_actions = _resolveComponent("modal-actions")!
  const _component_modal_layout = _resolveComponent("modal-layout")!
  const _component_modal_app = _resolveComponent("modal-app")!
  const _component_gd_modal = _resolveComponent("gd-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isRegistrationOverlayShown.value && !failedReason.value)
      ? (_openBlock(), _createBlock(_component_gd_modal, {
          key: 0,
          onCloseBG: closeRegistrationModal,
          onCloseESC: closeRegistrationModal,
          onClose: closeRegistrationModal,
          class: _normalizeClass(isProcessingRegistration.value ? 'modal-processing' : '')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_modal_app, { s: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_modal_layout, { "data-qe-id": "tournament-registration-state" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_c_loading_indicator, {
                      class: "modal-spinner",
                      show: isProcessingRegistration.value
                    }, null, 8, ["show"]),
                    (rejoin.value)
                      ? (_openBlock(), _createBlock(_component_modal_title, { key: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('tRegistration.main.title_rejoin')), 1)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_modal_title, { key: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('tRegistration.main.title')), 1)
                          ]),
                          _: 1
                        })),
                    _createVNode(_component_modal_content, null, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", null, _toDisplayString(tournament.value.name), 1),
                        _createVNode(CTournamentInfo, {
                          "tournament-ui": tournamentUi.value,
                          gameName: "",
                          totalWin: "",
                          addedPrize: "",
                          entryFee: "",
                          restartFee: "",
                          competitionDate: "",
                          lobbyTime: "",
                          registrationDate: "",
                          tournamentMode: "",
                          rejoin: rejoin.value
                        }, null, 8, ["tournament-ui", "rejoin"]),
                        (rejoin.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.$t('tRegistration.main.rejoin_text', { fee: tournamentUi.value.metaData.restartFee })), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_3, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((acceptanceBox).value = $event)),
                            id: "acceptance-box"
                          }, null, 512), [
                            [_vModelCheckbox, acceptanceBox.value]
                          ]),
                          _createElementVNode("label", {
                            innerHTML: md(_ctx.$t('tRegistration.main.acceptance')),
                            onClick: clickHandlerTerms,
                            for: "acceptance-box",
                            "data-qe-id": "checkbox-accept-tc"
                          }, null, 8, _hoisted_4),
                          _createVNode(CTerms, {
                            show: showTerms.value,
                            "is-masters": tournamentUi.value.isMasters,
                            "game-type": tournamentUi.value.gametype,
                            onCloseTerms: _cache[1] || (_cache[1] = ($event: any) => (showTerms.value = false))
                          }, null, 8, ["show", "is-masters", "game-type"])
                        ]),
                        (failedReasonInline.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(failedReasonInline.value), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_modal_actions, { class: "join-modal-actions" }, {
                      default: _withCtx(() => [
                        (!rejoin.value)
                          ? (_openBlock(), _createBlock(_component_t_button, {
                              key: 0,
                              onClick: onRegister,
                              yellow: "",
                              l: "",
                              "data-qe-id": "join-button"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('tRegistration.main.button_join', { fee: tournamentUi.value.metaData.entryFee })), 1)
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_t_button, {
                              key: 1,
                              onClick: onRegister,
                              yellow: "",
                              l: "",
                              "data-qe-id": "rejoin-button"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('tRegistration.main.button_join', { fee: tournamentUi.value.metaData.restartFee })), 1)
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"]))
      : (isRegistrationOverlayShown.value)
        ? (_openBlock(), _createBlock(CErrorModal, {
            key: 1,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (isRegistrationOverlayShown.value = false))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                onClick: clickHandler,
                innerHTML: md(_ctx.$t('tRegistration.error.' + failedReason.value))
              }, null, 8, _hoisted_6)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
  ]))
}
}

})